// ItzGreenMusic — Static Site Configuration
// ============================================
// This file is your single source of truth.
// Update links, EmailJS keys, and contact info here.

// ─── SIGNNOW INTEGRATION ─────────────────
// SignNow can redirect users to the welcome page after signing
// The redirect URL can include query params like ?name={signer_name}
// Configure your SignNow document to redirect to: [your-domain]/welcome?name={signer_first_name}
export const signNowConfig = {
  signingUrl: "https://signnow.com/s/t1R7BOhm",
  pdfPreviewUrl: "/itzgreen-sample-agreement.pdf",
  primaryButtonText: "EXECUTE AGREEMENT (DIGITAL)",
  secondaryButtonText: "Preview Terms (PDF)",
  // After signing, SignNow should redirect to this URL pattern:
  // Example redirect URL to configure in SignNow: https://[your-domain]/welcome?name={signer_first_name}
  welcomeRedirectPath: "/welcome",
};

// ─── LIVE LEDGER DATA (BMI Reconciliations) ─────────────────
export const liveLedgerData = [
  { date: "02/26/2026", title: "HOSTILE TAKEOVER", type: "Corporate Drill (Main Mix)", status: "Reconciled", bmiWorkNo: "077469072" },
  { date: "02/26/2026", title: "HOSTILE TAKEOVER", type: "Drum & Bass Mix", status: "Reconciled", bmiWorkNo: "077469124" },
  { date: "02/26/2026", title: "TERMINATION EVENT", type: "Trailer Hit Mix", status: "Reconciled", bmiWorkNo: "077469140" },
  { date: "02/26/2026", title: "THE FINE PRINT", type: "Corporate Drill (Main Mix)", status: "Reconciled", bmiWorkNo: "077469081" },
  { date: "02/26/2026", title: "TOTAL CONCENTRATION", type: "Cinematic Phonk", status: "Reconciled", bmiWorkNo: "077209114" },
  { date: "02/26/2026", title: "UPPER MOON ENERGY", type: "Cinematic Phonk", status: "Reconciled", bmiWorkNo: "077469337" },
];

// Sign up at https://www.emailjs.com (free tier: 200 emails/month)
// 1. Create a service (Gmail, Outlook, etc.)
// 2. Create an email template with variables: {{from_name}}, {{from_email}}, {{project}}, {{message}}
// 3. Paste your IDs below
export const emailjsConfig = {
  serviceId: "YOUR_SERVICE_ID",      // e.g. "service_abc123"
  templateId: "YOUR_TEMPLATE_ID",    // e.g. "template_xyz789"
  publicKey: "YOUR_PUBLIC_KEY",       // e.g. "u_1A2B3C4D5E"
};

// ─── EXTERNAL LINKS ───────────────
// Submission links for briefs
export const externalLinks = {
  // Brief submission links
  corporateDrill: "mailto:leaver@itzgreenmusic.com?subject=Submission:%20Corporate%20Drill%20Brief",
  industrialTension: "mailto:leaver@itzgreenmusic.com?subject=Submission:%20Industrial%20Tension%20Brief",
  
  // Catalog links (internal use only)
  fullCatalog: "#",
  customScoring: "#",

  // Artist Representation
  artistSubmission: "mailto:leaver@itzgreenmusic.com?subject=Catalog%20Consideration",
};

// ─── BRAND IMAGERY ─────────────────────────
// Professional studio/corporate imagery for site
export const brandImages = {
  studioConsole: "https://images.unsplash.com/photo-1702329203800-27c16b559276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbXVzaWMlMjBzdHVkaW8lMjBtaXhpbmclMjBjb25zb2xlJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc3MTk5ODk1M3ww&ixlib=rb-4.1.0&q=85",
  recordingStudio: "https://images.unsplash.com/photo-1675292310383-0f4ef53fa3ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxkYXJrJTIwbXVzaWMlMjBzdHVkaW8lMjBtaXhpbmclMjBjb25zb2xlJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc3MTk5ODk1M3ww&ixlib=rb-4.1.0&q=85",
  productionDesk: "https://images.unsplash.com/photo-1601389926382-bcf545a238ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxkYXJrJTIwbXVzaWMlMjBzdHVkaW8lMjBtaXhpbmclMjBjb25zb2xlJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc3MTk5ODk1M3ww&ixlib=rb-4.1.0&q=85",
};

// ─── BRAND LOGO (Corporate - No Artist Image) ────────────────────────
export const logoUrl = "https://customer-assets.emergentagent.com/job_artist-rights-hub/artifacts/j9pragkq_grok_image_x4ydsya.jpg";

export const siteConfig = {
  name: "ITZGREENMUSIC",
  tagline: "CINEMATIC TRAP. CORPORATE DRILL. HYBRID ORCHESTRAL.",
  heroTitle: "100% Human-Produced. One-Stop Cleared. Fully Reconciled.",
  heroSubtext: "ItzGreen Music is a premium production house and rights administration firm specializing in Contemporary R&B, Premium Commercial Lifestyle, and Authentic Cinematic Urban scores for film, television, and global branding.",
  trustStatement: "Executive Produced by Leaver Hall. Pre-Cleared for Global Sync.",
  copyright: `© 2026 ItzGreen Music Publishing. All Rights Reserved.`,
  recordLabel: "1248290 Records DK",
};

export const navigation = [
  { label: "CATALOG", href: "/catalog", isRoute: true },
  { label: "ROSTER", href: "/roster", isRoute: true },
  { label: "ABOUT", href: "/about", isRoute: true },
  { label: "LICENSING", href: "/licensing", isRoute: true },
  { label: "VAULT", href: "/vault", isRoute: true },
  { label: "JOIN THE ROSTER", href: "https://signnow.com/s/t1R7BOhm", isCta: true, isExternal: true },
];

export const capabilities = [
  {
    title: "FULL-STACK ADMINISTRATION",
    description: "BMI, The MLC, SoundExchange, and ISRC Registration included. We handle the paperwork so you can focus on the music.",
  },
  {
    title: "DIRECT-TO-SUPERVISOR PIPELINE",
    description: "No middle-man libraries. No 'royalty-free' scams. Direct access to TV & Film music supervisors.",
  },
  {
    title: "EXCLUSIVELY REPRESENTING THE NEW CORPORATE SOUND",
    description: "We curate high-tension, luxury aesthetic music for premium placements. Not accepting hobbyists.",
  },
];

// ─── THE 50% REALITY CHECK ─────────────────
export const realityCheck = {
  title: "ARE YOU LOSING 50% OF YOUR CHECK?",
  body: `Did you know that BMI and ASCAP hold 50% of your performance royalties (the "Publisher's Share") if you don't have a registered Administrator?

You are likely only collecting your Writer's Share. The rest sits in a "Black Box" until it expires.

ItzGreen Music is the Key.

We register your catalog as your Administrator to unlock that second check.`,
  bullets: [
    "You keep your Masters.",
    "You keep your Writer's Share.",
    "We collect the Publisher's Share and split it 50/50.",
  ],
  cta: "Don't let the major labels claim your unclaimed royalties."
};

export const dealStructure = [
  { label: "Copyright Ownership", value: "100% Artist Retained" },
  { label: "Sync Placement Fees", value: "50/50 Split" },
  { label: "Performance Royalties", value: "100% Writer's / 50% Publisher's" },
];

export const serviceBlocks = [
  {
    id: "vault-01",
    title: "BRIEF 01: CORPORATE DRILL",
    category: "ACTIVE A&R BRIEF",
    description: "High-tension, luxury aesthetic. Seeking 140-150 BPM, aggressive 808s, and orchestral strings. Must be 100% human-composed.",
    buttonText: "SUBMIT STEMS FOR THIS BRIEF",
    buttonLink: "mailto:leaver@itzgreenmusic.com?subject=Submission:%20Brief%2001%20Corporate%20Drill",
    image: "https://images.unsplash.com/photo-1702329203800-27c16b559276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbXVzaWMlMjBzdHVkaW8lMjBtaXhpbmclMjBjb25zb2xlJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc3MTk5ODk1M3ww&ixlib=rb-4.1.0&q=85",
    stats: [
      { label: "Status", value: "OPEN" },
      { label: "Priority", value: "HIGH" },
      { label: "Splits", value: "50/50" },
    ],
  },
  {
    id: "vault-02",
    title: "BRIEF 02: INDUSTRIAL TENSION",
    category: "ACTIVE A&R BRIEF",
    description: "Dark, cinematic, percussive-heavy cues. Zero melody preferred. Focus on 'ticking clock' sounds and low-end brass swells.",
    buttonText: "SUBMIT STEMS FOR THIS BRIEF",
    buttonLink: "mailto:leaver@itzgreenmusic.com?subject=Submission:%20Brief%2002%20Industrial%20Tension",
    image: "https://images.unsplash.com/photo-1675292310383-0f4ef53fa3ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxkYXJrJTIwbXVzaWMlMjBzdHVkaW8lMjBtaXhpbmclMjBjb25zb2xlJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc3MTk5ODk1M3ww&ixlib=rb-4.1.0&q=85",
    stats: [
      { label: "Status", value: "OPEN" },
      { label: "Priority", value: "HIGH" },
      { label: "Splits", value: "50/50" },
    ],
  },
  {
    id: "vault-03",
    title: "BRIEF 03: TECH/CYBER NOIR",
    category: "ACTIVE A&R BRIEF",
    description: "Minimalist synth beds, 90-110 BPM. Clean, atmospheric textures for deep-state or investigative scenes.",
    buttonText: "SUBMIT STEMS FOR THIS BRIEF",
    buttonLink: "mailto:leaver@itzgreenmusic.com?subject=Submission:%20Brief%2003%20Tech%20Cyber%20Noir",
    image: "https://images.unsplash.com/photo-1601389926382-bcf545a238ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxkYXJrJTIwbXVzaWMlMjBzdHVkaW8lMjBtaXhpbmclMjBjb25zb2xlJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc3MTk5ODk1M3ww&ixlib=rb-4.1.0&q=85",
    stats: [
      { label: "Status", value: "OPEN" },
      { label: "Priority", value: "HIGH" },
      { label: "Splits", value: "50/50" },
    ],
  },
];

export const contactInfo = {
  email: "leaver@itzgreenmusic.com",
  location: "Hoboken, NJ",
  manager: "Leaver Hall, Manager",
  specialty: "Premium Commercial Lifestyle & Cinematic Urban",
};

// ─── MARKET TICKER DATA (LIVE OPPORTUNITIES) ────────────────────
export const tickerData = [
  { name: "LIVE TERMINAL ACTIVE", meta: "Q2 PAYLOAD COMPLETE: \"ISLAND LOVE\" (FULL BROADCAST STEMS VAULTED)", direction: "up", status: "SECURED" },
  { name: "STRICT ZERO-AI GUARANTEE IN EFFECT", meta: "ONE-STOP CLEARANCE SECURED", direction: "up", status: "ENFORCED" },
  { name: "$110K ACTIVE PLACEMENT PIPELINE", meta: "4 BRIEFS TRACKED: COMMERCIAL + CRIME DRAMA + FEATURE FILM + BRAND", direction: "up", status: "LIVE" },
  { name: "MASTER & PUBLISHING GOVERNED INTERNALLY", meta: "CURRENTLY SOURCING: CINEMATIC TENSION & ESPORTS SLATES", direction: "up", status: "ACTIVE" },
  { name: "LIABILITY SHIELD ACTIVE", meta: "ALL ASSETS 100% HUMAN-PRODUCED", direction: "up", status: "LIVE" },
];

// ─── ARTIST RESOURCES ────────────────────
export const artistResources = [
  {
    id: "metadata",
    title: "METADATA AUDIT",
    description: "Validate your stems before submission. Ensure broadcast readiness.",
    icon: "CheckSquare",
    action: "START AUDIT",
    link: "/audit",
    isRoute: true
  },
  {
    id: "split-sheet",
    title: "SPLIT SHEET",
    description: "Standardized ownership agreement for co-writers.",
    icon: "Users",
    action: "GENERATE SPLIT SHEET",
    link: "/split-sheet",
    isRoute: true
  },
  {
    id: "isrc",
    title: "ISRC GENERATOR",
    description: "Request official codes for unreleased assets.",
    icon: "FilePlus",
    action: "REQUEST CODES",
    link: "mailto:leaver@itzgreenmusic.com?subject=Request:%20ISRC%20Generation"
  },
  {
    id: "onboarding",
    title: "ROYALTY SETUP",
    description: "Guide to linking BMI & SoundExchange.",
    icon: "BookOpen",
    action: "VIEW GUIDE",
    link: "/royalty-setup",
    isRoute: true
  }
];

// ─── VAULT CONFIG (Supervisor Access) ──────────────────────────
export const vaultConfig = {
  title: "CLIENT ACCESS PORTAL",
  subtitle: "AUTHORIZED SUPERVISORS ONLY",
  // Password for vault access
  password: "Itzgreen",
  description: "Pre-cleared sync assets ready for immediate placement. All tracks include Main Mix, Underscore, and Stems.",
  // Private DISCO playlist for vault insiders
  playlistLink: "https://s.disco.ac/iehlagwicrfg",
  tracks: [
    { title: "LIQUIDATION EVENT", bpm: 130, key: "Gm", type: "Tension / Thriller", status: "UNRELEASED" },
  ],
};

// ─── REDACTED CREDITS ──────────────────────
// "Classified" social proof — redacted project names
export const redactedCredits = [
  { project: "[REDACTED]", network: "STARZ", studio: null, status: "PENDING" },
  { project: "WOLF MAN", network: null, studio: "UNIVERSAL", status: "SUBMITTED" },
  { project: "[REDACTED]", network: "BET+", studio: null, status: "IN REVIEW" },
  { project: "[REDACTED]", network: null, studio: "A24", status: "CLEARED" },
  { project: "[REDACTED]", network: "NETFLIX", studio: null, status: "PENDING" },
];

// ─── EDITOR'S TOOLKIT (RENAMED TO POST-PRODUCTION ASSETS) ──────────────────────
export const postProductionAssets = [
  {
    title: "RISERS & HITS",
    description: "Industrial risers, impacts, and tension hits.",
    format: "70 Files",
    downloadUrl: "/assets/IGM_Editor_Toolkit_Vol.zip", 
    status: "active" 
  },
  {
    title: "30-SEC LOOPS",
    description: "Tempo-locked underscore loops for quick temp tracks.",
    format: "30 Files",
    downloadUrl: "/assets/IGM_Editor_Toolkit_Vol.zip", // Using same zip as filler if needed, or #
    status: "active"
  }
];

// Kept for backward compatibility if needed, but we will update HomePage to use postProductionAssets
export const editorToolkit = {
    title: "POST-PRODUCTION ASSETS",
    subtitle: "Ready-to-cut sound design elements for your edit bay.",
    packs: postProductionAssets // We can map this if we want to minimize code changes, but better to update component
};


export const inquiries = [];

// ─── PLACEMENT PARTNERS ────────────────────
// Networks/studios with active or completed placements
export const placementPartners = [
  { name: "UNIVERSAL", type: "Studio" },
  { name: "STARZ", type: "Network" },
  { name: "A24", type: "Studio" },
  { name: "BET+", type: "Network" },
  { name: "NETFLIX", type: "Network" },
];

// ─── VAULT TEASER ──────────────────────────
export const vaultTeaser = {
  headline: "THE VAULT",
  subline: "Classified Assets — Unreleased Inventory",
  description: "Exclusive pre-release tracks available only for sync placement. Request access to hear material before it hits streaming.",
  ctaText: "REQUEST VAULT ACCESS",
  ctaLink: "/vault",
};

// ─── ROSTER DATA (Signed Composers & Producers) ─────────────────

export const supervisorToolkit = [
  {
    title: "EXECUTIVE SUMMARY",
    description: "Full mission profile, operational data, and contact info.",
    format: "PDF",
    downloadUrl: "/assets/IGM_Executive_Summary.pdf", 
    status: "active" 
  },
  {
    title: "ASSET LEDGER",
    description: "Quick-reference search codes and direct links for heavy assets.",
    format: "PDF",
    downloadUrl: "/assets/IGM_Asset_Ledger.pdf", 
    status: "active"
  },
  {
    title: "CUE SHEET TEMPLATE",
    description: "Pre-filled cue sheet template with ItzGreenMusic publishing info and IPI.",
    format: "XLSX",
    downloadUrl: "#", 
    status: "coming-soon" 
  },
  {
    title: "LICENSING TERMS",
    description: "Standard sync licensing terms, rates, and one-stop clearance documentation.",
    format: "PDF",
    downloadUrl: "#", 
    status: "coming-soon"
  }
];


// ═══════════════════════════════════════════════════════════════════════════════
// B2B SUPERVISOR VAULT CATALOGS
// Organized by TV Use-Case for rapid supervisor deployment
// Legal Status: 100% Human-Produced | One-Stop Cleared (BMI/The MLC)
// ═══════════════════════════════════════════════════════════════════════════════

// ═══════════════════════════════════════════════════════════════════════════════
// PUBLIC CATALOG DATA (Legacy/Public Facing)
// ═══════════════════════════════════════════════════════════════════════════════
export const catalogData = {
  suiteName: "ITZGREEN MUSIC CATALOG",
  description: "Premium production music for film, television, and advertising. 100% human-produced, one-stop cleared.",
  categories: [
    {
      id: "scripted-drama",
      title: "SCRIPTED DRAMA & MODERN R&B",
      subtitle: "Character-Driven / Emotional Pacing",
      icon: "Tv", // Storing icon name as string for serialization
      vibe: "Late-night atmospheric tension, emotional beats, premium episodic television.",
      producer: "Nijay Scott / ItzGreen Music",
      tracks: [
        { 
          id: "trk_captivated_01",
          title: "Captivated",
          artist: "Nijay Scott",
          genre: "Contemporary R&B",
          mood: "Moody, Cinematic, Groove",
          clearance: "One-Stop (100% Master & Publishing)",
          production: "100% Human-Produced",
          description: "Radio-ready contemporary R&B. Fully indemnified with zero uncleared samples.",
          bpm: 88, 
          key: "A Minor", 
          duration: "3:52", 
          mix: "Main Mix",
          streamUrl: "https://customer-assets.emergentagent.com/job_05bb89b9-bd12-4211-ba45-1fade7c1a42d/artifacts/oef1co14_Captivated-RnB-Groove%202.mp3" 
        },
        { 
          id: "trk_submission_03",
          title: "Submission",
          artist: "ItzGreen Music",
          genre: "Contemporary R&B / Pop",
          mood: "Smooth, Commercial, Anthemic",
          clearance: "One-Stop (100% Master & Publishing)",
          production: "100% Human-Produced",
          description: "Broadcast-ready R&B crossover. Fully reconciled liability shield.",
          bpm: 90, 
          key: "C Minor", 
          duration: "3:45", 
          mix: "Main Mix",
          streamUrl: "https://customer-assets.emergentagent.com/job_05bb89b9-bd12-4211-ba45-1fade7c1a42d/artifacts/m0u2g38n_Submission_RnB.wav" 
        },
        { id: "halo", title: "HALO", mix: "Main Mix", bpm: 95, key: "G Minor", duration: "4:02", genre: "R&B Groove", streamUrl: "https://customer-assets.emergentagent.com/job_05bb89b9-bd12-4211-ba45-1fade7c1a42d/artifacts/h0xdj9vx_Halo-RnB-Groove.m4a" },
        { id: "contagious-love", title: "CONTAGIOUS LOVE", mix: "Main Mix", bpm: 95, key: "E Minor", duration: "3:38", genre: "Modern R&B", streamUrl: "https://customer-assets.emergentagent.com/job_05bb89b9-bd12-4211-ba45-1fade7c1a42d/artifacts/kmg43mq5_Contagious%20Love.mp3" },
      ]
    },
    {
      id: "reality-lifestyle",
      title: "UNSCRIPTED REALITY & TRANSITIONAL",
      subtitle: "High-Energy House / Dance",
      icon: "Zap", // Storing icon name as string
      vibe: "Scene transitions, lifestyle background music, reality show underscore.",
      producer: "Nijay Scott, OSHAANE / ItzGreen Music",
      tracks: [
        { 
          id: "trk_malibu_02",
          title: "Malibu",
          artist: "ItzGreen Music",
          genre: "House / Dance",
          mood: "High-Energy, Club, Upbeat",
          clearance: "One-Stop (100% Master & Publishing)",
          production: "100% Human-Produced",
          description: "Commercial house and dance asset. Clean stems available upon supervisor request.",
          bpm: 124, 
          key: "A Minor", 
          duration: "3:42", 
          mix: "Main Mix",
          streamUrl: "https://customer-assets.emergentagent.com/job_05bb89b9-bd12-4211-ba45-1fade7c1a42d/artifacts/qaiptlhf_Malibu%20HouseDance.wav" 
        },
        { id: "leave-you-alone", title: "LEAVE YOU ALONE", mix: "Main Mix", bpm: 122, key: "G Minor", duration: "3:55", genre: "House/Dance", streamUrl: "https://customer-assets.emergentagent.com/job_05bb89b9-bd12-4211-ba45-1fade7c1a42d/artifacts/i0mkaay2_Leave%20You%20Alone-HouseDance%20.mp3" },
      ]
    }
  ]
};

// ═══════════════════════════════════════════════════════════════════════════════
// B2B SUPERVISOR VAULT CATALOGS
// Organized by TV Use-Case for rapid supervisor deployment
// Legal Status: 100% Human-Produced | One-Stop Cleared (BMI/The MLC)
// ═══════════════════════════════════════════════════════════════════════════════

export const vaultCatalogs = [
  {
    id: "q2-premium-drama",
    title: "PREMIUM DRAMA & CINEMATIC R&B",
    subtitle: "Targeting: Starz, HBO Max, Hulu Slates | Crime Drama Series",
    vibe: "Late-night tension, emotional pacing, premium character-driven scenes. Funk & soul-infused grooves for crime drama. Dialogue-safe instrumentals included.",
    icon: "Tv",
    producer: "Nijay Scott / ItzGreen Music",
    metadata: {
      publisher: "ItzGreen Music LLC / Lanae Sincere Publishing (ASCAP)",
      syncAdmin: "ItzGreen Music LLC (Exclusive Sync Administrator)",
      clearance: "100% One-Stop Cleared (Master & Pub)",
      composer: "Garland Jared Scott Perry (ASCAP)",
      contact: "leaverhall@gmail.com | itzgreenmusic.com"
    },
    tracks: [
      {
        id: "nj-used-main",
        title: "USED",
        artist: "Nijay Scott",
        bpm: "90",
        key: "Cm",
        duration: "3:18",
        genre: "Cinematic R&B / Late Night",
        mix: "Main Mix",
        contact: "leaverhall@gmail.com",
        clearance: "100% ONE-STOP | LIABILITY SHIELD SECURED",
        production: "100% Human-Produced",
        streamUrl: "/assets/nijay_scott/used/ITZGREEN_NijayScott_Used_MainMix.wav",
        versions: [
          { mix: "Main Mix", file: "ITZGREEN_NijayScott_Used_MainMix.wav", url: "/assets/nijay_scott/used/ITZGREEN_NijayScott_Used_MainMix.wav", status: "LIVE" },
          { mix: "Acapella", file: "ITZGREEN_NijayScott_Used_Acapella.wav", url: "/assets/nijay_scott/used/ITZGREEN_NijayScott_Used_Acapella.wav", status: "LIVE" },
          { mix: "Instrumental", file: "ITZGREEN_NijayScott_Used_Inst.wav", url: "/assets/nijay_scott/used/ITZGREEN_NijayScott_Used_Inst.wav", status: "LIVE" },
          { mix: "TV Mix", file: "ITZGREEN_NijayScott_Used_TVMix.wav", url: "/assets/nijay_scott/used/ITZGREEN_NijayScott_Used_TVMix.wav", status: "LIVE" },
        ]
      },
    ]
  },
  {
    id: "q2-reality-lifestyle",
    title: "UNSCRIPTED REALITY & LIFESTYLE",
    subtitle: "Targeting: Bravo, Peacock, MTV, Travel Brands | Transportation & Lifestyle Commercials",
    vibe: "Bright, Island-influenced, feel-good energy for lifestyle montages, confessionals, travel sequences, and brand commercials. Upbeat, groovy, and broadcast-ready.",
    icon: "Sun",
    producer: "Nijay Scott / ItzGreen Music",
    metadata: {
      publisher: "ItzGreen Music LLC / Lanae Sincere Publishing (ASCAP)",
      syncAdmin: "ItzGreen Music LLC (Exclusive Sync Administrator)",
      clearance: "100% One-Stop Cleared (Master & Pub)",
      composer: "Garland Jared Scott Perry (ASCAP)",
      contact: "leaverhall@gmail.com | itzgreenmusic.com"
    },
    tracks: [
      {
        id: "nj-island-love-main",
        title: "ISLAND LOVE",
        artist: "Nijay Scott",
        bpm: "100",
        key: "Eb",
        duration: "2:58",
        genre: "Island Pop / Lifestyle",
        mix: "Main Mix",
        contact: "leaverhall@gmail.com",
        clearance: "100% ONE-STOP | LIABILITY SHIELD SECURED",
        production: "100% Human-Produced",
        streamUrl: "/assets/nijay_scott/island_love/ITZGREEN_NijayScott_IslandLove_MainMix.wav",
        versions: [
          { mix: "Main Mix", file: "ITZGREEN_NijayScott_IslandLove_MainMix.wav", url: "/assets/nijay_scott/island_love/ITZGREEN_NijayScott_IslandLove_MainMix.wav", status: "LIVE" },
          { mix: "Instrumental", file: "ITZGREEN_NijayScott_IslandLove_Inst.wav", url: "/assets/nijay_scott/island_love/ITZGREEN_NijayScott_IslandLove_Inst.wav", status: "LIVE" },
          { mix: "Acapella", file: "ITZGREEN_NijayScott_IslandLove_Acapella.wav", url: "/assets/nijay_scott/island_love/ITZGREEN_NijayScott_IslandLove_Acapella.wav", status: "LIVE" },
          { mix: "TV Mix", file: "ITZGREEN_NijayScott_IslandLove_TVMix.wav", url: null, status: "AWAITING DELIVERY" },
        ]
      },
    ]
  },
  {
    id: "q2-jwest-cinematic",
    title: "CINEMATIC R&B INSTRUMENTALS",
    subtitle: "Targeting: Premium Drama, Film Trailers, Ad Campaigns | Feature Film & Brand Commercials",
    vibe: "Smooth R&B grooves designed for underscore, dialogue scenes, emotional montages, and high-energy brand spots. No vocals — production-ready instrumentals.",
    icon: "Tv",
    producer: "J West / ItzGreen Music",
    metadata: {
      publisher: "ItzGreen Music",
      clearance: "100% One-Stop Cleared (Master & Pub)",
      composer: "J West",
      contact: "leaverhall@gmail.com | itzgreenmusic.com"
    },
    tracks: [
      {
        id: "jw-captivated-inst",
        title: "CAPTIVATED",
        artist: "J West",
        bpm: "95",
        key: "Ab",
        duration: "3:12",
        genre: "R&B Groove / Cinematic",
        mix: "Instrumental",
        contact: "leaverhall@gmail.com",
        clearance: "100% ONE-STOP | LIABILITY SHIELD SECURED",
        production: "100% Human-Produced",
        streamUrl: "/assets/j_west/captivated/ITZGREEN_JWest_Captivated_Inst.wav",
        versions: [
          { mix: "Instrumental", file: "ITZGREEN_JWest_Captivated_Inst.wav", url: "/assets/j_west/captivated/ITZGREEN_JWest_Captivated_Inst.wav", status: "LIVE" },
        ]
      },
      {
        id: "jw-halo-inst",
        title: "HALO",
        artist: "J West",
        bpm: "90",
        key: "Fm",
        duration: "3:45",
        genre: "R&B Groove / Cinematic",
        mix: "Instrumental",
        contact: "leaverhall@gmail.com",
        clearance: "100% ONE-STOP | LIABILITY SHIELD SECURED",
        production: "100% Human-Produced",
        streamUrl: "/assets/j_west/captivated/ITZGREEN_JWest_Halo_Inst.wav",
        versions: [
          { mix: "Instrumental", file: "ITZGREEN_JWest_Halo_Inst.wav", url: "/assets/j_west/captivated/ITZGREEN_JWest_Halo_Inst.wav", status: "LIVE" },
        ]
      },
      {
        id: "jw-elevate",
        title: "ELEVATE",
        artist: "J West",
        bpm: "128",
        key: "Bb",
        duration: "3:00",
        genre: "Upbeat Pop / Commercial",
        mix: "Main Mix",
        contact: "leaverhall@gmail.com",
        clearance: "100% ONE-STOP | LIABILITY SHIELD SECURED",
        production: "100% Human-Produced",
        streamUrl: "https://customer-assets.emergentagent.com/job_b6b3e499-22cd-4757-abc5-7e9436e55594/artifacts/439xkujg_JWest_PhoneCommercial_Main_UpbeatPop_OneStop_ItzGreenMusic.wav",
        versions: [
          { mix: "Main Mix", file: "ITZGREEN_JWest_Elevate_MainMix.wav", url: "https://customer-assets.emergentagent.com/job_b6b3e499-22cd-4757-abc5-7e9436e55594/artifacts/439xkujg_JWest_PhoneCommercial_Main_UpbeatPop_OneStop_ItzGreenMusic.wav", status: "LIVE" },
        ]
      },
    ]
  },
  {
    id: "vocal-toplines",
    title: "VOCAL TOP-LINES & COMMERCIAL VO",
    subtitle: "Commercial Reads / Hook Agency",
    vibe: "Clean, high-fidelity vocal stems for custom scoring. 100% Human-Produced, Zero Generative AI, Master & Publishing Controlled.",
    icon: "Mic",
    producer: "Nijay Scott / ItzGreen Music",
    tracks: [
      { 
        id: "sprite-ad-spec-vocal-stem", 
        title: "NIJAY SCOTT - SPRITE AD SPEC - VOCAL STEM ONLY", 
        bpm: 110, 
        key: "C Major", 
        duration: "0:32", 
        genre: "Commercial VO",
        mix: "Dry Vocal Stem",
        contact: "leaver@itzgreenmusic.com",
        clearance: "100% ONE-STOP | LIABILITY SHIELD SECURED",
        streamUrl: "https://customer-assets.emergentagent.com/job_05bb89b9-bd12-4211-ba45-1fade7c1a42d/artifacts/kfa8sy31_Sprite%20Radio%20Commercial%20Concept%20.m4a"
      },
    ]
  },
  {
    id: "q2-priority-nijay",
    title: "Q2 Priority: Contemporary Drama",
    subtitle: "High-Tension R&B and Cinematic assets.",
    description: "100% Human-Produced. One-Stop Cleared. High-Tension R&B and Cinematic assets.",
    vibe: "Sensual / Atmospheric / Introspective / Tense",
    icon: "Zap", // Added default icon since user didn't provide one, Zap fits "Priority"
    producer: "Nijay Scott / ItzGreen Music",
    coverImage: "/images/q2-nijay-cover.jpg",
    tracks: [
      {
        id: "nj-you-know-it",
        title: "You Know It",
        artist: "Nijay Scott",
        bpm: "85",
        key: "N/A", // Default
        duration: "N/A", // Default
        genre: "Sensual / Atmospheric",
        mix: "Main Mix",
        contact: "leaver@itzgreenmusic.com",
        clearance: "100% ONE-STOP",
        streamUrl: "https://customer-assets.emergentagent.com/job_b6b3e499-22cd-4757-abc5-7e9436e55594/artifacts/fdn5qbtw_Cadillac%20-%20Trap%20Groove%20.wav" // Mapping 'Cadillac' as it's the only one left without a clear match
      },
      {
        id: "nj-issues",
        title: "Issues",
        artist: "Nijay Scott",
        bpm: "95",
        key: "N/A",
        duration: "N/A",
        genre: "Introspective / Tense",
        mix: "Main Mix",
        contact: "leaver@itzgreenmusic.com",
        clearance: "100% ONE-STOP",
        streamUrl: "https://customer-assets.emergentagent.com/job_b6b3e499-22cd-4757-abc5-7e9436e55594/artifacts/phuckqae_Issues%20.wav"
      },
      {
        id: "nj-it-was",
        title: "It Was What It Was",
        artist: "Nijay Scott",
        bpm: "75",
        key: "N/A",
        duration: "N/A",
        genre: "Melancholic / Climax",
        mix: "Main Mix",
        contact: "leaver@itzgreenmusic.com",
        clearance: "100% ONE-STOP",
        streamUrl: "https://customer-assets.emergentagent.com/job_b6b3e499-22cd-4757-abc5-7e9436e55594/artifacts/20bvpadj_4.%20It%20was%20what%20it%20was%20By%20NijayScott.wav"
      },
      {
        id: "nj-make-me-do",
        title: "MakeMeDo",
        artist: "Nijay Scott",
        bpm: "110",
        key: "N/A",
        duration: "N/A",
        genre: "Energetic / Flirtatious",
        mix: "Main Mix",
        contact: "leaver@itzgreenmusic.com",
        clearance: "100% ONE-STOP",
        streamUrl: "https://customer-assets.emergentagent.com/job_b6b3e499-22cd-4757-abc5-7e9436e55594/artifacts/zifcq00j_2.%20MakeMeDo%20by%20NijayScott.wav"
      },
      {
        id: "nj-used-clean",
        title: "USED (Clean Edit)",
        artist: "Nijay Scott",
        bpm: "95",
        key: "N/A",
        duration: "N/A",
        genre: "Confrontational / Resolute",
        mix: "Clean Edit",
        contact: "leaver@itzgreenmusic.com",
        clearance: "100% ONE-STOP",
        streamUrl: "https://customer-assets.emergentagent.com/job_b6b3e499-22cd-4757-abc5-7e9436e55594/artifacts/fd0y1qov_NIJAY%20SCOTT%20USED%20-%20Pop.RnB.Rap%20clean.wav"
      },
      {
        id: "nj-cadillac",
        title: "Cadillac",
        artist: "Nijay Scott",
        bpm: "130",
        key: "N/A",
        duration: "N/A",
        genre: "Trap Groove",
        mix: "Main Mix",
        contact: "leaver@itzgreenmusic.com",
        clearance: "100% ONE-STOP",
        streamUrl: "https://customer-assets.emergentagent.com/job_b6b3e499-22cd-4757-abc5-7e9436e55594/artifacts/bztx020o_Cadillac%20-%20Trap%20Groove%20.wav"
      },
      {
        id: "nj-love-you-down",
        title: "Love You Down",
        artist: "Nijay Scott",
        bpm: "68",
        key: "N/A",
        duration: "N/A",
        genre: "Slow Jam / Ballad",
        mix: "Main Mix",
        contact: "leaver@itzgreenmusic.com",
        clearance: "100% ONE-STOP",
        streamUrl: "https://customer-assets.emergentagent.com/job_b6b3e499-22cd-4757-abc5-7e9436e55594/artifacts/wach2p55_love%20you%20down.wav"
      },
      {
        id: "nj-fame-international",
        title: "FAME - International",
        artist: "Nijay Scott",
        bpm: "105",
        key: "N/A",
        duration: "N/A",
        genre: "Afrobeat / Dancehall",
        mix: "Main Mix",
        contact: "leaver@itzgreenmusic.com",
        clearance: "100% ONE-STOP",
        streamUrl: "https://customer-assets.emergentagent.com/job_b6b3e499-22cd-4757-abc5-7e9436e55594/artifacts/1rdxlwg0_FAME%20-%20International.wav"
      },
      {
        id: "nj-why-uptempo",
        title: "Why",
        artist: "Nijay Scott",
        bpm: "118",
        key: "N/A",
        duration: "N/A",
        genre: "Trap-R&B / Uptempo",
        mix: "Main Mix",
        contact: "leaver@itzgreenmusic.com",
        clearance: "100% ONE-STOP",
        streamUrl: "https://customer-assets.emergentagent.com/job_b6b3e499-22cd-4757-abc5-7e9436e55594/artifacts/o9qw61gf_Why%20-%20%20R%26b%20Uptempo%20.wav"
      },
      {
        id: "nj-love-uptempo",
        title: "Love (Uptempo)",
        artist: "Nijay Scott",
        bpm: "122",
        key: "N/A",
        duration: "N/A",
        genre: "Pop-R&B / Dance",
        mix: "Main Mix",
        contact: "leaver@itzgreenmusic.com",
        clearance: "100% ONE-STOP",
        streamUrl: "https://customer-assets.emergentagent.com/job_b6b3e499-22cd-4757-abc5-7e9436e55594/artifacts/i29arkfv_Nijay%20Scott%20-%20Love%20-%20Uptempo.wav"
      }
    ]
  }
];

export const rosterData = [
  {
    id: "nijay-scott",
    name: "Nijay Scott",
    legalName: "Garland Jared Scott Perry",
    role: "Recording Artist & Songwriter",
    focus: "Corporate Drill / Tension Hip-Hop / Sports Sync",
    clearance: "100% Vault Sync Publishing (One-Stop)",
    location: "Harlem, New York",
    pro: "ASCAP",
    ipi: "00511525787",
    background: "Nijay Scott serves as the frontline vocal and lyrical architect for the ItzGreen Music sync catalog. Hailing from Harlem, his lifelong creative partnership with ItzGreen producer J.West forms the foundation of our urban roster. Together, they engineer the exact propulsive, high-energy aesthetic currently driving modern commercial broadcast.",
    image: "https://customer-assets.emergentagent.com/job_05bb89b9-bd12-4211-ba45-1fade7c1a42d/artifacts/hsrjess2_Screenshot_20260305-190908~2.png", 
    initials: "NS",
    verified: true,
    photo: "https://customer-assets.emergentagent.com/job_05bb89b9-bd12-4211-ba45-1fade7c1a42d/artifacts/hsrjess2_Screenshot_20260305-190908~2.png"
  },
  {
    id: "well-made-choice",
    name: "Well Made Choice",
    legalName: "Telfair Carson",
    role: "Producer & Recording Artist",
    focus: "High-Tension Cinematic / Corporate Drill",
    clearance: "100% Vault Sync Publishing (One-Stop)",
    location: "Harlem, New York (150th St.)",
    pro: "BMI",
    ipi: "275791034",
    background: "Originating from 150th Street in Harlem, Telfair Carson—operating professionally as Well Made Choice—completes the core triad of ItzGreen Music's foundational urban roster. Growing up alongside Nijay Scott and J.West, this lifelong synergy allows ItzGreen to offer music supervisors a highly cohesive and authentic creative collective.",
    image: "https://customer-assets.emergentagent.com/job_05bb89b9-bd12-4211-ba45-1fade7c1a42d/artifacts/xp6jc7fh_Screenshot_20260306-150337~2.png", // Using hosted URL
    initials: "WC",
    verified: true,
    photo: "https://customer-assets.emergentagent.com/job_05bb89b9-bd12-4211-ba45-1fade7c1a42d/artifacts/xp6jc7fh_Screenshot_20260306-150337~2.png"
  },
  {
    id: "j-west",
    name: "J WEST",
    legalName: "Jamar West",
    role: "Exclusive Producer",
    focus: "Corporate Drill / Hip-Hop / Score",
    clearance: "100% Vault Sync Publishing (One-Stop)",
    status: "EXCLUSIVE",
    location: "Harlem, New York",
    background: "As the sonic architect behind the ItzGreen Music sound, Jamar 'J.West' West defines the label's signature 'Corporate Drill' aesthetic. A Harlem native and lifelong collaborator with Nijay Scott and Well Made Choice, J.West engineers high-pressure, cinematic soundscapes designed specifically for modern broadcast. His production style balances gritty, authentic textures with the polish required for major network syncs.",
    image: "https://customer-assets.emergentagent.com/job_b6b3e499-22cd-4757-abc5-7e9436e55594/artifacts/zfqv3zmw_Resized_IMG_20260117_203313~3.jpeg",
    initials: "JW",
    verified: true,
    photo: "https://customer-assets.emergentagent.com/job_b6b3e499-22cd-4757-abc5-7e9436e55594/artifacts/zfqv3zmw_Resized_IMG_20260117_203313~3.jpeg"
  }
];

// ═══════════════════════════════════════════════════════════════════════════════
// ANALYTICS MOCK DATA (Executive Dashboard)
// ═══════════════════════════════════════════════════════════════════════════════
export const analyticsData = {
  kpi: [
    { label: "LIVE ACTIVE USERS", value: "3", change: "+2", status: "active" },
    { label: "TOTAL VAULT LOGINS (24H)", value: "12", change: "+150%", status: "positive" },
    { label: "INGESTION PORTAL HITS", value: "48", change: "+24%", status: "positive" }
  ],
  ledger: [
    { id: 1, timestamp: "Today, 14:02 EST", location: "Los Angeles, CA", source: "Direct (Email Link)", action: "Vault Entered", user: "Gabe Hilfer (Probable)" },
    { id: 2, timestamp: "Today, 13:45 EST", location: "New York, NY", source: "LinkedIn", action: "Catalog Download", user: "Network Supervisor" },
    { id: 3, timestamp: "Today, 11:20 EST", location: "Nashville, TN", source: "Search", action: "Ingestion Portal", user: "Unknown Producer" },
    { id: 4, timestamp: "Yesterday, 16:55 EST", location: "Santa Monica, CA", source: "Direct", action: "Q2 Priority Stream", user: "Trailer Park Group" },
    { id: 5, timestamp: "Yesterday, 09:30 EST", location: "London, UK", source: "Referral", action: "About Page View", user: "International Desk" },
  ],
  geo: [
    { city: "Los Angeles, CA", count: 45, percentage: 65 },
    { city: "New York, NY", count: 12, percentage: 18 },
    { city: "Atlanta, GA", count: 5, percentage: 7 },
    { city: "London, UK", count: 4, percentage: 6 },
    { city: "Nashville, TN", count: 3, percentage: 4 },
  ]
};
